<mat-card class="login-info-screen-wrapper">
  <div class="icon">
    <img [src]="icon" alt="success-icon">
  </div>
  <div class="title">{{title}}</div>
  <div class="text">{{text}}</div>
  @if (awsApiRequestId) {
    <div class="text" style="font-style: italic; color: #9f9f9f">ID: {{awsApiRequestId}}</div>
  }
  @if (success) {
    <div class="redirecting-timer">{{'LOGIN.SUCCESS_REDIRECT_1' | translate}} {{countdown | async}} {{'LOGIN.SUCCESS_REDIRECT_2' | translate}}</div>
  }
  @if (!success) {
    <button (click)="goBack()">{{'LOGIN.BUTTON_ERROR_GO_BACK' | translate}}</button>
  }
</mat-card>
